import React from "react";
import { useTranslation } from "react-i18next";
import imageSrc from "../../assets/images/testimonial-alejandro.png";
import imageSrc1 from "../../assets/images/testimonial.png";
import imageSrc2 from "../../assets/images/testimonial-luis.png";

const Testimonials: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="testimonials" className="banner neumorphic-container rounded-0 p-5 mb-0">
      <div className="container col-lg-12 mb-5">
        <h2 className="text-center">{t("testimonials.title")}</h2>
        <h3 className="text-center">{t("testimonials.subtitle")}</h3>
      </div>
      <div className="row">
        <div className="col-12 col-md-4 mb-4">
          <section className="teaser testimonial neumorphic-container p-3 rounded-5 h-100">
            <p className="text color-sixth">{t("testimonials.alejandro.quote")}</p>
            <div className="d-flex">
              <div>
                <div className="testimonial-image-container neumorphic-container p-2 rounded-4 overflow-hidden">
                  <img className="testimonial-image" src={imageSrc} alt="Alejandro M."/>
                </div>
              </div>
              <ul>
                <li className="text gradient-text">{t("testimonials.alejandro.name")}</li>
                <li className="text color-sixth">{t("testimonials.alejandro.title")}</li>
                <li className="text color-sixth fst-italic fw-lighter">{t("testimonials.alejandro.location")}</li>
              </ul>
            </div>
          </section>
        </div>
        <div className="col-12 col-md-4 mb-4">
          <section className="teaser testimonial neumorphic-container p-3 rounded-5 h-100">
            <p className="text color-sixth">{t("testimonials.natalia.quote")}</p>
            <div className="d-flex">
              <div>
                <div className="testimonial-image-container neumorphic-container p-2 rounded-4 overflow-hidden">
                  <img className="testimonial-image" src={imageSrc1} alt="Natalia V."/>
                </div>
              </div>
              <ul>
                <li className="text gradient-text">{t("testimonials.natalia.name")}</li>
                <li className="text color-sixth">{t("testimonials.natalia.title")}</li>
                <li className="text color-sixth fst-italic fw-lighter">{t("testimonials.natalia.location")}</li>
              </ul>
            </div>
          </section>
        </div>
        <div className="col-12 col-md-4 mb-4">
          <section className="teaser testimonial neumorphic-container p-3 rounded-5 h-100">
            <p className="text color-sixth">{t("testimonials.luis.quote")}</p>
            <div className="d-flex">
              <div>
                <div className="testimonial-image-container neumorphic-container p-2 rounded-4 overflow-hidden">
                  <img className="testimonial-image" src={imageSrc2} alt="Luis R."/>
                </div>
              </div>
              <ul>
                <li className="text gradient-text">{t("testimonials.luis.name")}</li>
                <li className="text color-sixth">{t("testimonials.luis.title")}</li>
                <li className="text color-sixth fst-italic fw-lighter">{t("testimonials.luis.location")}</li>
              </ul>
            </div>
          </section>
        </div>
      </div>
    </section>
  );
}
export default Testimonials;
